import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Column, Row } from './MarketItem';
import ArrowDownSvg from 'assets/images/icons/arrow_down.svg';
import theme from 'styles/theme';
import { FilterType } from './MarketHome';
// import ArrowUpSvg from 'assets/images/icons/arrow_up.svg';

function MarketHomeFilterBar({ resultsCount, filterType, handleFilterType }) {
   const [isOpenFilter, setOpenFilter] = useState(false);
   const openFilter = () => setOpenFilter(true);
   const closeFilter = () => setOpenFilter(false);
   const onChangeFilter = filter => {
      handleFilterType(filter);
      setOpenFilter(false);
   };
   const filters = Object.keys(FilterType);

   useEffect(() => {
      return () => {
         closeFilter();
      };
   }, []);

   return (
      <MarketHomeFilterBarWrap>
         <ResultsText>
            <BoldText color={theme.color.black}>{resultsCount}개</BoldText>의 도매상
         </ResultsText>

         <Filter onClick={openFilter}>
            <BoldText weight={400}>{FilterType[filterType]}</BoldText>
            <ArrowIcon src={isOpenFilter ? ArrowDownSvg : ArrowDownSvg} alt="arrow" />
         </Filter>

         {isOpenFilter && (
            <FilterTooltip>
               {filters.map(filter => {
                  const isSelected = filterType === filter;
                  return (
                     <FilterTypeText
                        key={filter}
                        isSelected={isSelected}
                        onClick={() => onChangeFilter(filter)}
                     >
                        {FilterType[filter]}
                     </FilterTypeText>
                  );
               })}
            </FilterTooltip>
         )}
      </MarketHomeFilterBarWrap>
   );
}

export default MarketHomeFilterBar;

// common
const BoldText = styled.span`
   font-weight: ${({weight}) => weight || 700};
   color : ${({color}) => color}
`;

const MarketHomeFilterBarWrap = styled(Row)`
   position: relative;
   justify-content: space-between;
   padding: 14px 16px;
`;

const ResultsText = styled.div``;

const Filter = styled(Row)`
   cursor: pointer;
   user-select: none;
`;

const ArrowIcon = styled.img`
   width: 24px;
   height: 24px;
`;

const FilterTypeText = styled.div`
   color: ${({ isSelected }) => (isSelected ? theme.color.gray100 : theme.color.black)};
`;
const FilterTooltip = styled(Column)`
   position: absolute;
   right: 16px;
   top: 42px;
   background-color: ${theme.color.white};
   font-size: 14px;
   line-height: 20px;
   padding: 16px 12px 16px 12px;
   border-radius: 8px;
   z-index: 10;
   gap: 4px;
   box-shadow: 3px 3px 20px rgba(34, 37, 41, 0.1);

   ${FilterTypeText} {
      font-weight: 400;
      width: 70px;
      cursor: pointer;
      padding: 2px 0px;
      user-select: none;

      &:hover {
         border-radius: 6px;
         background-color: ${theme.color.gray100};
         transition: all 0.3s;
      }
   }
`;
